import {
    showImpairedCuedRecallSummary,
    showImpairedIntrusionsPIERatioSummary,
    showImpairedPerformanceOnListBIntrusions,
    showImpairedTwoMarginalSummary,
    showMarginalOneItemSummary,
    showResultNormal,
    showTotalLearningBorderlineSummary,
    showTotalLearningUninterpretableSummary
} from "@helpers/summaryHelper";
import { AssessmentScores } from "@store/generalTypes";
import { Translate } from "react-i18nify";
import { Summary } from "./summary";

export const PerformanceSummary = ({ ...props }: PerformanceSummaryProps): JSX.Element => {
    return (
        <div className="box is-shadowless">
            {props.score.totalLearning !== undefined && showTotalLearningBorderlineSummary(props.score) && (
                <Summary
                    title={<Translate value="admin.totalLearningScore" />}
                    score={
                        <span className="has-text-orange">
                            <Translate value="admin.borderline" />
                        </span>
                    }
                    clinicianComment={<Translate value="admin.scoring.totalLearning.maringal.clinicalComment" />}
                    researchComment={<Translate value="admin.scoring.totalLearning.maringal.researchComment" />}
                />
            )}
            {props.score.totalLearning !== undefined && showImpairedPerformanceOnListBIntrusions(props.score) && (
                <Summary
                    title={<Translate value={"admin.assessmentResults"} />}
                    score={
                        <span className="has-text-danger">
                            <Translate value={"admin.scoring.showImpairedPerformanceOnListBIntrusions.scoreTitle"} />
                        </span>
                    }
                    label1={<Translate value={"admin.scoring.showImpairedPerformanceOnListBIntrusions.label1"} />}
                    label2={<Translate value={"admin.scoring.showImpairedPerformanceOnListBIntrusions.label2"} />}
                />
            )}
            {props.score.totalLearning !== undefined && showTotalLearningUninterpretableSummary(props.score) && (
                <Summary
                    title={<Translate value="admin.assessmentResults" />}
                    score={
                        <span className="has-text-danger">
                            <Translate value="admin.scoring.totalLearning.uninterpretable.title" />
                        </span>
                    }
                    label1={<Translate value="admin.scoring.totalLearning.uninterpretable.label1" />}
                    label2={<Translate value="admin.scoring.totalLearning.uninterpretable.label2" />}
                />
            )}
            {showImpairedCuedRecallSummary(props.score) && (
                <Summary
                    title={<Translate value={"admin.assessmentResults"} />}
                    score={
                        <span className="has-text-danger">
                            <Translate value={"admin.scoring.cuedRecall.scoreTitle"} />
                        </span>
                    }
                    label1={<Translate value={"admin.scoring.cuedRecall.label1"} />}
                    label2={<Translate value={"admin.scoring.cuedRecall.label2"} />}
                />
            )}
            {showImpairedIntrusionsPIERatioSummary(props.score) && (
                <Summary
                    title={<Translate value={"admin.assessmentResults"} />}
                    score={
                        <span className="has-text-danger">
                            <Translate value={"admin.scoring.intrusionsPieRatio.scoreTitle"} />
                        </span>
                    }
                    label1={<Translate value={"admin.scoring.intrusionsPieRatio.label1"} />}
                    label2={<Translate value={"admin.scoring.intrusionsPieRatio.label2"} />}
                />
            )}
            {showImpairedTwoMarginalSummary(props.score) && (
                <Summary
                    title={<Translate value={"admin.assessmentResults"} />}
                    score={
                        <span className="has-text-danger">
                            <Translate value={"admin.scoring.impairedTwoOrMoreMarginal.scoreTitle"} />
                        </span>
                    }
                    label1={<Translate value={"admin.scoring.impairedTwoOrMoreMarginal.label1"} />}
                />
            )}
            {showMarginalOneItemSummary(props.score) && (
                <Summary
                    title={<Translate value={"admin.assessmentResults"} />}
                    score={
                        <span className="has-text-orange">
                            <Translate value="admin.scoring.marginalPerformanceRecallOrIntrusions.scoreTitle" />
                        </span>
                    }
                    label1={<Translate value={"admin.scoring.marginalPerformanceRecallOrIntrusions.label1"} />}
                />
            )}
            {props.score.totalLearning !== undefined && showResultNormal(props.score) && (
                <Summary
                    score={
                        <span className="has-text-success">
                            <Translate value={"admin.scoring.totalLearning.normalScore.title"} />
                        </span>
                    }
                    title={<Translate value={"admin.assessmentResults"} />}
                    label1={<Translate value="admin.scoring.totalLearning.normalScore.label1" />}
                    label2={<Translate value="admin.scoring.totalLearning.normalScore.label2" />}
                />
            )}
        </div>
    );
};

interface PerformanceSummaryProps {
    score: AssessmentScores;
}
